// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
// import '../Styles/ResetPassword.css';
// import logo from '../Images/savilogo.png';
// import Navbar from './Navbar';

// const ResetPassword = () => {
//   const [email, setEmail] = useState('');
//   const [message, setMessage] = useState('');
//   const [isSubmitted, setIsSubmitted] = useState(false);
//   const [showOtpPopup, setShowOtpPopup] = useState(false);
//   const [otp, setOtp] = useState('');

//   const handleChange = (e) => {
//     setEmail(e.target.value);
//   };

//   const handleOtpChange = (e) => {
//     setOtp(e.target.value);
//   };

//   const validateEmail = (email) => {
//     const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     return re.test(email);
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     // Check if email is provided
//     if (!email) {
//       setMessage('Please enter your email address');
//       return;
//     }

//     // Validate email format
//     if (!validateEmail(email)) {
//       setMessage('Please enter a valid email address');
//       return;
//     }

//     // Show OTP popup for valid email
//     setShowOtpPopup(true);
//     setMessage('An OTP has been sent to your email');
//     setIsSubmitted(true);
//   };

//   const handleVerifyOtp = (e) => {
//     e.preventDefault();

//     if (!otp) {
//       setMessage('Please enter the OTP');
//       return;
//     }

//     // Here you would verify the OTP with your backend
//     // For now, we'll just show a success message
//     setMessage('OTP verified successfully. You can now reset your password.');
//     // You would typically redirect to a password reset page here
//   };

//   const handleClosePopup = () => {
//     setShowOtpPopup(false);
//     setOtp('');
//   };

//   return (
//     <div className='reset_total'>
//       <Navbar />
//       <div className="reset_sectionContainer">

//         {/* Reset Password Box */}
//         <div className="reset_resetBox">
//           <img src={logo} alt="SAVI AI Logo" className="reset_logo" />

//           <h1 className="reset_title">Reset Password?</h1>

//           <form onSubmit={handleSubmit} className="reset_formInputs">
//             {/* <p className="reset_instructions">
//               No worries, we'll send you reset instructions.
//             </p> */}

//             <div className="reset_inputContainer">
//               <input
//                 type="email"
//                 name="email"
//                 placeholder="Enter Your Email"
//                 className="reset_input"
//                 value={email}
//                 onChange={handleChange}
//               />
//               <div className="reset_emailIcon">✉️</div>
//             </div>

//             {message && (
//               <p className={`reset_message ${isSubmitted ? "reset_success" : "reset_error"}`}>
//                 {message}
//               </p>
//             )}

//             <div className="reset_buttonSection">
//               <button type="submit" className="reset_resetBtn">
//                 Continue
//               </button>
//             </div>
//           </form>

//           <div className="reset_backSection">
//             <Link to="/login" className="reset_backLink">
//               <span className="reset_backArrow">←</span> Back to Log in
//             </Link>
//           </div>
//         </div>

//         {/* Promo Box */}
//         <div className="reset_promoBox">
//           <div className='reset_heroText'>
//             <h2>Supercharge your business and productivity</h2>
//             <p>Chat to start writing, planning, learning, and more with SAVI AI</p>
//           </div>
//         </div>
//       </div>

//       {/* OTP Popup */}
//       {showOtpPopup && (
//         <div className="reset_otpOverlay">
//           <div className="reset_otpPopup">
//             <div className="reset_otpCloseBtn" onClick={handleClosePopup}>×</div>
//             <h2>Enter OTP</h2>
//             <p>Please enter the one-time password sent to {email}</p>

//             <form onSubmit={handleVerifyOtp}>
//               <div className="reset_otpInputContainer">
//                 <input
//                   type="text"
//                   placeholder="Enter OTP"
//                   className="reset_otpInput"
//                   value={otp}
//                   onChange={handleOtpChange}
//                   maxLength="6"
//                 />
//               </div>

//               <button type="submit" className="reset_verifyBtn">
//                 Verify OTP
//               </button>
//             </form>

//             <div className="reset_otpFooter">
//               <p>Didn't receive the code? <span className="reset_resendLink">Resend</span></p>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ResetPassword;









import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../Styles/ResetPassword.css';
import logo from '../Images/savilogo.png';
// import Navbar from './Navbar';
import { FiMail, FiLock } from 'react-icons/fi';
import savilogo from '../Images/savilogo.png';

const ResetPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [showOtpPopup, setShowOtpPopup] = useState(false);
  const [showPasswordPopup, setShowPasswordPopup] = useState(false);
  const [otp, setOtp] = useState('');
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordMessage, setPasswordMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
      const savedTheme = localStorage.getItem('theme') || 'light';
      document.documentElement.setAttribute('data-theme', savedTheme);
    }, []);
    useEffect(() => {
      // Set theme on mount
      const setTheme = () => {
        const savedTheme = localStorage.getItem('theme') || 'light';
        document.documentElement.setAttribute('data-theme', savedTheme);
      };
      setTheme();
  
      // Listen for theme changes in other tabs/components
      const handleStorage = (e) => {
        if (e.key === 'theme') {
          setTheme();
        }
      };
      window.addEventListener('storage', handleStorage);
  
      return () => window.removeEventListener('storage', handleStorage);
    }, []);

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const handleOtpChange = (e) => {
    setOtp(e.target.value);
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Check if email is provided
    if (!email) {
      setMessage('Please enter your email address');
      return;
    }

    // Validate email format
    if (!validateEmail(email)) {
      setMessage('Please enter a valid email address');
      return;
    }

    // Show OTP popup for valid email
    setShowOtpPopup(true);
    setMessage('An OTP has been sent to your email');
    setIsSubmitted(true);
  };

  const handleVerifyOtp = (e) => {
    e.preventDefault();

    if (!otp) {
      setMessage('Please enter the OTP');
      return;
    }

    // Verify OTP length is 6 digits
    if (otp.length === 6) {
      // Here you would verify the OTP with your backend
      setMessage('OTP verified successfully.');

      // Close OTP popup and show password reset popup
      setShowOtpPopup(false);
      setShowPasswordPopup(true);
    } else {
      setMessage('Please enter a valid 6-digit OTP');
    }
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case 'oldPassword':
        setOldPassword(value);
        break;
      case 'newPassword':
        setNewPassword(value);
        break;
      case 'confirmPassword':
        setConfirmPassword(value);
        break;
      default:
        break;
    }
  };

  const handlePasswordSubmit = (e) => {
    e.preventDefault();

    // Validate passwords
    if (!oldPassword) {
      setPasswordMessage('Please enter your old password');
      return;
    }

    if (!newPassword) {
      setPasswordMessage('Please enter your new password');
      return;
    }

    if (newPassword.length < 8) {
      setPasswordMessage('New password must be at least 8 characters long');
      return;
    }

    if (newPassword !== confirmPassword) {
      setPasswordMessage('New password and confirm password do not match');
      return;
    }

    // Here you would send the password change request to your backend
    setPasswordMessage('Password reset successful!');

    // You could redirect to login page or show success message
    setTimeout(() => {
      setShowPasswordPopup(false);
      setMessage('Password has been reset successfully. You can now login with your new password.');
      // Optional: Clear all fields and return to initial state
      setOldPassword('');
      setNewPassword('');
      setConfirmPassword('');
    }, 2000);
  };

  const handleClosePopup = () => {
    setShowOtpPopup(false);
    setOtp('');
  };

  const handleClosePasswordPopup = () => {
    setShowPasswordPopup(false);
    setOldPassword('');
    setNewPassword('');
    setConfirmPassword('');
  };

  const handleSignIn = () => {
    navigate('/login');
  };

  return (
    <div className='reset_total'>
      {/* <Navbar /> */}

      <header className="savi-header">
      
              <div className="header-logo">
                <img src={savilogo} alt="SAVI AI"  style={{ opacity: 0 }}/>
                {/* <img src={savilogo} alt="SAVI AI" /> */}
              </div>
              <div className="header-nav">
                {/* <div className="nav-links">
                  <a href="#business">For business</a>
                  <a href="#faq">FAQ</a>
                </div> */}
                {/* <button className="menu-dots">⋮</button> */}
                <button className="sign-in-btn" onClick={handleSignIn}>Sign In</button>
              </div>
            </header>
      <div className="reset_sectionContainer">

        {/* Reset Password Box */}
        <div className="reset_resetBox">
          <img src={logo} alt="SAVI AI Logo" className="reset_logo" />

          <h1 className="reset_title">Reset Password?</h1>

          <form onSubmit={handleSubmit} className="reset_formInputs">
            {/* <div className="reset_inputContainer">
              <input
                type="email"
                name="email"
                placeholder="Enter Your Email"
                className="reset_input"
                value={email}
                onChange={handleChange}
              />
              <div className="reset_emailIcon">✉️</div>
            </div> */}
            <div className="reset_inputContainer">
              <input
                type="email"
                name="email"
                placeholder="Enter Your Email"
                className="reset_input"
                value={email}
                onChange={handleChange}
              />
              <div className="reset_emailIcon">
                <FiMail />
              </div>
            </div>

            {message && (
              <p className={`reset_message ${isSubmitted ? "reset_success" : "reset_error"}`}>
                {message}
              </p>
            )}

            <div className="reset_buttonSection">
              <button type="submit" className="reset_resetBtn">
                Continue
              </button>
            </div>
          </form>

          <div className="reset_backSection">
            <Link to="/login" className="reset_backLink">
              <span className="reset_backArrow">←</span> Back to Log in
            </Link>
          </div>
        </div>

        {/* Promo Box */}
        <div className="reset_promoBox">
          <div className='reset_heroText'>
            <h2>Supercharge your business and productivity</h2>
            <p>Chat to start writing, planning, learning, and more with SAVI AI</p>
          </div>
        </div>
      </div>

      {/* OTP Popup */}
      {showOtpPopup && (
        <div className="reset_otpOverlay">
          <div className="reset_otpPopup">
            <div className="reset_otpCloseBtn" onClick={handleClosePopup}>×</div>
            <h2>Enter OTP</h2>
            <p>Please enter the one-time password sent to {email}</p>

            <form onSubmit={handleVerifyOtp}>
              <div className="reset_otpInputContainer">
                <input
                  type="text"
                  placeholder="Enter OTP"
                  className="reset_otpInput"
                  value={otp}
                  onChange={handleOtpChange}
                  maxLength="6"
                />
              </div>

              <button type="submit" className="reset_verifyBtn">
                Verify OTP
              </button>
            </form>

            <div className="reset_otpFooter">
              <p>Didn't receive the code? <span className="reset_resendLink">Resend</span></p>
            </div>
          </div>
        </div>
      )}

      {/* Password Reset Popup */}
      {showPasswordPopup && (
        <div className="reset_otpOverlay">
          <div className="reset_otpPopup reset_passwordPopup">
            <div className="reset_otpCloseBtn" onClick={handleClosePasswordPopup}>×</div>
            <h2>Reset Your Password</h2>
            <p>Please enter your old password and create a new password</p>

            <form onSubmit={handlePasswordSubmit}>
              {/* <div className="reset_passwordInputContainer">
                <input
                  type="password"
                  name="oldPassword"
                  placeholder="Old Password"
                  className="reset_passwordInput"
                  value={oldPassword}
                  onChange={handlePasswordChange}
                />
              </div>

              <div className="reset_passwordInputContainer">
                <input
                  type="password"
                  name="newPassword"
                  placeholder="New Password"
                  className="reset_passwordInput"
                  value={newPassword}
                  onChange={handlePasswordChange}
                />
              </div>

              <div className="reset_passwordInputContainer">
                <input
                  type="password"
                  name="confirmPassword"
                  placeholder="Confirm Password"
                  className="reset_passwordInput"
                  value={confirmPassword}
                  onChange={handlePasswordChange}
                />
              </div> */}

              <div className="reset_passwordInputContainer">
                <input
                  type="password"
                  name="oldPassword"
                  placeholder="Old Password"
                  className="reset_passwordInput"
                  value={oldPassword}
                  onChange={handlePasswordChange}
                />
                {/* <div className="reset_passwordIcon">
                  <FiLock />
                </div> */}
              </div>

              <div className="reset_passwordInputContainer">
                <input
                  type="password"
                  name="newPassword"
                  placeholder="New Password"
                  className="reset_passwordInput"
                  value={newPassword}
                  onChange={handlePasswordChange}
                />
                {/* <div className="reset_passwordIcon">
                  <FiLock />
                </div> */}
              </div>

              <div className="reset_passwordInputContainer">
                <input
                  type="password"
                  name="confirmPassword"
                  placeholder="Confirm Password"
                  className="reset_passwordInput"
                  value={confirmPassword}
                  onChange={handlePasswordChange}
                />
                {/* <div className="reset_passwordIcon">
                  <FiLock />
                </div> */}
              </div>
              {passwordMessage && (
                <p className={`reset_message ${passwordMessage.includes('successful') ? "reset_success" : "reset_error"}`}>
                  {passwordMessage}
                </p>
              )}

              <button type="submit" className="reset_verifyBtn">
                Reset Password
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default ResetPassword;